import { Box, VStack } from "native-base";
import React from "react";
import { FlatList } from "react-native";

import TabBar from "@/components/molecules/TabBar";
import Container from "@/components/organisms/Container";
import WebHeader from "@/components/organisms/WebHeader";
import { useAppNavigation } from "@/hooks/application/navigation";
import { RootNavigation } from "@/navigation/Root";

import CardLoading from "../components/CardLoading";
import EmptyCard from "../components/EmptyCard";
import ProductCard from "../components/ProductCard";
import SortCard from "../components/SortCard";
import StoreCard from "../components/StoreCard";
import { GlobalSearchScreenProps } from "../types";

const GlobalSearchWeb = ({
  products,
  stores,
  total,
  isLoading,
  currentSearch,
  handleSearch,
  onBackPress,
  onSelectSortType,
}: GlobalSearchScreenProps) => {
  const { navigate } = useAppNavigation<RootNavigation>();
  const renderLoader = () => (
    <FlatList
      data={new Array(10).fill(null)}
      numColumns={2}
      keyExtractor={(_, index) => index.toString()}
      showsVerticalScrollIndicator={false}
      renderItem={() => <CardLoading />}
    />
  );
  return (
    <Container
      Header={
        <WebHeader
          title="Busca"
          disableBuiltInSearch={true}
          onChangeSearch={handleSearch}
          onPressBack={onBackPress}
        />
      }>
      <VStack py="4">
        {(!products && !isLoading) || products?.length === 0 ? (
          <EmptyCard
            currentSearch={products?.length === 0 ? currentSearch : null}
            onSelectRecentQuery={(val) => {
              handleSearch(val);
            }}
          />
        ) : (
          <TabBar
            scenes={[
              {
                key: "tab-products",
                title: total ? `Itens (${total})` : "Itens",
                component: () => (
                  <VStack p="2">
                    <SortCard onSelectSortOption={onSelectSortType} />
                    {!!isLoading && renderLoader()}
                    {!!products?.length && !isLoading && (
                      <FlatList
                        data={products}
                        numColumns={2}
                        horizontal={false}
                        keyExtractor={(item, index) => (item ? item._id : index.toString())}
                        showsVerticalScrollIndicator={false}
                        renderItem={({ item }) => (
                          <Box w="45%">
                            <ProductCard
                              product={item}
                              onSelectProduct={() =>
                                navigate("homeStack", {
                                  screen: "product",
                                  params: {
                                    productId: item._id,
                                  },
                                })
                              }
                            />
                          </Box>
                        )}
                        columnWrapperStyle={{ justifyContent: "space-evenly" }}
                      />
                    )}
                  </VStack>
                ),
              },
              {
                key: "tab-stores",
                title: stores ? `Lojas (${stores?.length})` : "Lojas",
                component: () => (
                  <VStack p="2">
                    {!!isLoading && renderLoader()}
                    {!!stores?.length && !isLoading && (
                      <FlatList
                        data={stores}
                        numColumns={2}
                        horizontal={false}
                        keyExtractor={(item, index) => (item ? item._id : index.toString())}
                        showsVerticalScrollIndicator={false}
                        renderItem={({ item }) => (
                          <Box w="45%">
                            <StoreCard store={item} />
                          </Box>
                        )}
                        columnWrapperStyle={{ justifyContent: "space-evenly" }}
                      />
                    )}
                  </VStack>
                ),
              },
            ]}
          />
        )}
      </VStack>
    </Container>
  );
};

export default GlobalSearchWeb;
